var templateUrl = require('./notifications.html');

angular.module('ciApp').component('notifications', {
  templateUrl: templateUrl,
  controller: [
    '$timeout',
    'Notify',
    function($timeout, Notify) {
      var ctrl = this;

      function handler(e, notification) {
        notification[notification.level] = true;

        // Get rid of previous duplicate errors
        _.chain(ctrl.notifications)
          .filter({ message: notification.message })
          .each(function(item) {
            ctrl.resolve(item);
          })
          .value();

        ctrl.notifications.push(notification);

        $timeout(function() {
          ctrl.resolve(notification);
        }, 6000);
      }
      ctrl.$onInit = function() {
        ctrl.notifications = [];
        Notify.on(handler);
      };

      ctrl.resolve = function(notification) {
        var index = ctrl.notifications.indexOf(notification);
        ctrl.notifications.splice(index, 1);
      };
    }
  ]
});



// WEBPACK FOOTER //
// ./common/components/notifications/notifications.component.js